import config from '../config.json'

import { isMobileOnly } from 'react-device-detect';

import { fadeOut, selectElementContents, getColoresGlobales, reducirTamano, destroyElement, ubicarDivSegunCoordenada } from './../utils/domUtils';
import { redondearDosString } from '../utils/dataUtils';
import { ActionEstadosWidgetsInvertirValor, EstadosWidgets } from '../classes/reducerClasses';

const avisoFullScreenId = "avisoFullScreenId";
const avisoVisorEsActual = "avisoVisorEsActual"
const coloresGlobales = getColoresGlobales();

function createAviso(id, color, texto, centrado = true, clickToClose = true, otroIdDestroy = null){
    destroyElement(id);
    const divAviso = document.createElement("div");
    divAviso.id = id;
    divAviso.classList.add("panelAviso");
    if (centrado){
        divAviso.classList.add("panelCentrado");
    }
    divAviso.style.color = color;
    divAviso.innerHTML = texto;
    if (clickToClose){
        divAviso.title = "Cerrar";
        divAviso.style.cursor = "pointer";
        divAviso.addEventListener("click", () => {
            destroyElement(id);
            if (otroIdDestroy){
                destroyElement(otroIdDestroy);
            }
        });
    }
    return divAviso;
}

export function destroyAvisoVisorEsActual(){
    destroyElement(avisoVisorEsActual);
}
export function createAvisoVisorEsActual(){
    const divAviso = createAviso(avisoVisorEsActual, coloresGlobales.base, "El visor seleccionado es el actual");
    document.body.appendChild(divAviso);
    fadeOut(divAviso, 1, 3);
}

export function destroyAvisoFullScreen(){
    destroyElement(avisoFullScreenId);
}
export function createAvisoFullScreen(mapView, widgtetFullScreen){
    const divAviso = createAviso(avisoFullScreenId, coloresGlobales.importante, "Utiliza el modo de pantalla completa");
    const fullScreenContainer = widgtetFullScreen.container;

    divAviso.addEventListener("click", () => {
        fullScreenContainer.style.border = "none";
        widgtetFullScreen.viewModel.enter();
    });
    fullScreenContainer.addEventListener("click", () => {
        destroyAvisoFullScreen();
        fullScreenContainer.style.border = "none";
    });
    mapView.ui.add(divAviso, "manual");
}

function createCirculoCoordenadaCopiada(top, left){
    destroyElement(config.domIds.circuloCoordenadaCopiadaId);
    const divCrear = document.createElement("div");
    divCrear.id = config.domIds.circuloCoordenadaCopiadaId;
    divCrear.style.top = top - config.tamanoCirculoCopiarCoordenada / 2 + "px"
    divCrear.style.left = left - config.tamanoCirculoCopiarCoordenada / 2 + "px"
    divCrear.style.width = config.tamanoCirculoCopiarCoordenada + "px"
    divCrear.style.height = config.tamanoCirculoCopiarCoordenada + "px"
    divCrear.style.borderRadius = config.tamanoCirculoCopiarCoordenada / 2 + "px"
    divCrear.classList.add("circuloCopiarCoordenada");
    return divCrear
}

function agregarCirculoCoordenadaClick(mapView, mapPoint, conFadeOut = true){
    const divCirculo = createCirculoCoordenadaCopiada(mapView.toScreen(mapPoint).y, mapView.toScreen(mapPoint).x);
    mapView.ui.add(divCirculo, "manual");
    if (conFadeOut){
        fadeOut(divCirculo, 1);
    }
    reducirTamano(divCirculo, config.tamanoCirculoCopiarCoordenada, config.tamanoCirculoCopiarCoordenadaMin, mapView.toScreen(mapPoint).y, mapView.toScreen(mapPoint).x);
    return divCirculo;
}

export function operacionesCopiarCoordenada(mapView, mapPoint, textCoos = null, enPortapapeles = true){
    const divCirculo = agregarCirculoCoordenadaClick(mapView, mapPoint, enPortapapeles);
    const mensaje = enPortapapeles ? `Coordenada ${redondearDosString(mapPoint.latitude)}  ${redondearDosString(mapPoint.longitude)} copiada` : textCoos;
    const divAviso = createAviso(config.domIds.avisoCoordenadaCopiadaId, coloresGlobales.aceptado, mensaje, isMobileOnly, true, divCirculo.id);
    if (!isMobileOnly){
        ubicarDivSegunCoordenada(divAviso, mapView.toScreen(mapPoint).y, mapView.toScreen(mapPoint).x, config.tamanoCirculoCopiarCoordenada);
    }
    mapView.ui.add(divAviso, "manual");
    if (enPortapapeles){
        fadeOut(divAviso, 1);
    } else {
        divAviso.classList.add("panelCopiarCoordenada");
        if (!isMobileOnly){
            selectElementContents(divAviso);
        }
    }
}

export function createButton(esriIconClass, title, containerClass = "customButtonClass", containerIconClass = "customButtonIconoClass", ocultar = true){
    const container = document.createElement("div");
    if (ocultar){
        container.style.display = "none"; //Se ocultan al crearlos para mostrar todos cuando ya estén resueltos
    }
    const containerIcono = document.createElement("div");

    container.appendChild(containerIcono);
    containerIcono.classList.add(esriIconClass, containerIconClass);
    container.classList.add(containerClass);
    container.title = title;
    return [container, containerIcono];
}

function createButtonEsri(texto){
    const button  = document.createElement("button");
    button.innerHTML = texto;
    button.classList.add("esri-button");
    return button;
}

function botonUrlDetalleLayer(esriIconClass, titleBoton, urlDetalle, avisoNoUrl){
    const [container] = createButton(esriIconClass, titleBoton, "customButtonLayerClass", "customButtonLayerIconoClass", false);
    container.addEventListener("click", () => {
        if (urlDetalle){
            window.open(urlDetalle, '_blank', 'noopener,noreferrer');
        } else {
            alert(avisoNoUrl);
        }
    });
    return container;
}

function botonFuncionDetalleLayer(esriIconClass, titleBoton, setInfoLayer, infoLayer, dispatchEstadosWidgets, cerrarInfoAdicional){
    const [container] = createButton(esriIconClass, titleBoton, "customButtonLayerClass", "customButtonLayerIconoClass", false);
    container.addEventListener("click", () => {
        if (infoLayer){
            dispatchEstadosWidgets(new ActionEstadosWidgetsInvertirValor(EstadosWidgets.propInfoLayerCambio));
            cerrarInfoAdicional();
            setInfoLayer(infoLayer);
        } else {
            alert("No fue posible acceder a la información de la capa");
        }
    });
    return container;
}

export function panelBotonesDetalleLayer(setInfoLayer, infoLayer, dispatchEstadosWidgets, cerrarInfoAdicional){
    const domBotonServicio = botonUrlDetalleLayer("esri-icon-documentation", "Ver servicio WEB geográfico", infoLayer.urlServicio, "Esta capa no tiene un servicio WEB asociado");
    const domBotonDescarga = botonUrlDetalleLayer("esri-icon-download", "Descargar en formato Shapefile", infoLayer.urlDescarga, "¡Muy pronto podrás descargar ésta y otras capas!");
    const domBotonInfo = botonFuncionDetalleLayer("esri-icon-description", "Ver información de la fuente y fecha de actualización", setInfoLayer, infoLayer, dispatchEstadosWidgets, cerrarInfoAdicional);
    domBotonServicio.classList.add("botonDetalleLayer");
    domBotonDescarga.classList.add("botonDetalleLayer");
    domBotonInfo.classList.add("botonDetalleLayer");
    const domPanel = document.createElement("div");
    domPanel.className = "panelBotonesDetalleLayer";
    domPanel.appendChild(domBotonServicio);
    domPanel.appendChild(domBotonDescarga);
    domPanel.appendChild(domBotonInfo);
    return domPanel;
}

export function avisoConfirmacion(mensaje, funcionConfirmar, parametrosFuncion = []){
    const divAviso = createAviso(config.domIds.avisoConfirmacion, coloresGlobales.base, mensaje, true, false);
    divAviso.classList.add("panelAvisoConfirmacion");
    document.body.appendChild(divAviso);
    const buttonAceptar = createButtonEsri("Aceptar");
    buttonAceptar.addEventListener("click", () => {
        funcionConfirmar(...parametrosFuncion);
        destroyElement(divAviso.id);
    });
    const buttonCancelar = createButtonEsri("Cancelar");
    buttonCancelar.addEventListener("click", () => {
        destroyElement(divAviso.id);
    });

    const divButtons = document.createElement("div");
    divButtons.style.paddingTop = "10px";
    const tableButtons = document.createElement("table");
    const rowButtons = tableButtons.insertRow();
    const celdaAceptar = rowButtons.insertCell();
    const celdaCancelar = rowButtons.insertCell();

    tableButtons.style.width = "100%";

    celdaAceptar.style.width = "50%";
    celdaCancelar.style.width = "50%";

    celdaAceptar.appendChild(buttonAceptar);
    celdaCancelar.appendChild(buttonCancelar);
    divButtons.appendChild(tableButtons);
    divAviso.appendChild(divButtons);
}

